import { Button } from "@hatch-digital-nl/abs-storybook/legacy";
import { JSX } from "react";

interface Props {
    isPatchEditEmployeeLoading: boolean;
}

export const SubmitButtonComponent = (props: Props): JSX.Element => {
    const { isPatchEditEmployeeLoading } = props;

    return (
        <div
            className={
                "c-edit-employee-modal__form-group c-edit-employee-modal__form-group--button"
            }
        >
            <Button
                loading={isPatchEditEmployeeLoading}
                disabled={isPatchEditEmployeeLoading}
                variant={"primary"}
                type={"submit"}
            >
                Wijzigingen opslaan
            </Button>
        </div>
    );
};
